import React from "react";
import Select, { selectComponents } from "../common/select";

export default function ChannelSelector({ channels, onChange }) {
  const channelOptions = React.useMemo(
    () =>
      channels.map((channel) => ({
        label: channel.label,
        value: channel.external_id,
      })),
    [channels]
  );

  const ValueContainer = ({ children, ...props }) => {
    const { getValue } = props;
    const selected = getValue();

    return (
      <selectComponents.ValueContainer {...props}>
        {selected.length > 0
          ? `${selected.length} option${
              selected.length > 1 ? "s" : ""
            } selected`
          : children}
      </selectComponents.ValueContainer>
    );
  };

  return (
    <div className="channel-select">
      <Select
        name="channel"
        isMulti={true}
        placeholder="All Channels"
        options={channelOptions}
        onChange={(input) => onChange(input)}
        classNamePrefix="react-select"
        components={{ ValueContainer }}
        containerClass="react-select-container--fill"
      />
    </div>
  );
}
